import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ChatIntent } from '../models/guide.model';

/** Task summary sent to the backend classifier so the registry stays
 *  single-sourced on the front-end. */
export interface TaskSummary {
  id: string;
  title: string;
  triggerPhrases: string[];
}

/** FAQ summary sent to the backend classifier so the FAQ knowledge base stays
 *  single-sourced on the front-end. */
export interface FaqSummary {
  id: string;
  question: string;
  triggerPhrases: string[];
}

/**
 * Calls the backend LLM classifier `POST /ai/classify-intent`. The Firebase
 * Bearer token is attached automatically by the auth interceptor (internal
 * origin). This is the backend counterpart of the local `IntentMatcherService`,
 * which callers keep as a fallback if the request fails.
 */
@Injectable({ providedIn: 'root' })
export class IntentClassifierService {
  private readonly http = inject(HttpClient);

  classify(message: string, tasks: TaskSummary[], faqs: FaqSummary[] = []): Promise<ChatIntent> {
    const url = `${environment.shout_api.url}/ai/classify-intent`;
    return firstValueFrom(
      this.http.post<ChatIntent>(url, { message, tasks, faqs }).pipe(take(1)),
    );
  }
}
